"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addRecipeToSectionMutationOptions = exports.addRecipeToSectionMutation = void 0;
const client_1 = require("@apollo/client");
const recipesByCookbookAndSectionId_1 = require("../../recipe/queries/recipesByCookbookAndSectionId");
exports.addRecipeToSectionMutation = client_1.gql `
  mutation AddRecipeToSection($recipeId: String!, $sectionId: String!) {
    addRecipeToSection(recipeId: $recipeId, sectionId: $sectionId) {
      __typename
      ok
    }
  }
`;
exports.addRecipeToSectionMutationOptions = (variables, recipe) => ({
    variables,
    update: store => {
        let data;
        try {
            data = store.readQuery({
                query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
                variables: { sectionId: variables.sectionId },
            });
        }
        catch (_a) {
            return;
        }
        if (data) {
            store.writeQuery({
                query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
                variables: { sectionId: variables.sectionId },
                data: {
                    __typename: "Query",
                    recipesByCookbookAndSectionId: [
                        ...data.recipesByCookbookAndSectionId,
                        recipe,
                    ],
                },
            });
        }
    },
});
//# sourceMappingURL=addRecipeToSection.js.map